module.exports = __webpack_public_path__ + "img/logobeta.551535bc.svg";